import { SETableColumnsProps } from "../../../../components/SETable";

export const tableColumns = (): SETableColumnsProps[] => [
  {
    id: "descricao",
    label: "Descrição",
    minWidth: 10,
    align: "left",
    columnStyle: {
      overflowWrap: "break-word",
      width: 900,
      wordBreak: "break-word",
      whiteSpace: "break-spaces",
    },
  },
  {
    id: "total",
    label: "Quantidade",
    minWidth: 100,
    align: "center",
  },
];
